var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconQuoteSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "14px",
    viewBox: "0 0 24 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Graphics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-521.000000, -206.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-quote-small",
    transform: "translate(521.000000, 206.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "currentColor",
    strokeWidth: 2,
    x: 1,
    y: 1,
    width: 22,
    height: 16,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5,9.8625 C12.5,7.292 14.446,4.603 17.5,4 L17.992,5.063 C16.8845,5.4805 15.9105,6.934 15.802,7.936 C17.0475,8.132 18,9.2095 18,10.5105 C18,12.1015 16.708,13 15.4005,13 C13.893,13 12.5,11.8475 12.5,9.8625 Z M6,9.8625 C6,7.292 7.946,4.603 11,4 L11.492,5.063 C10.3845,5.4805 9.4105,6.934 9.302,7.936 C10.5475,8.132 11.5,9.2095 11.5,10.5105 C11.5,12.1015 10.208,13 8.9005,13 C7.393,13 6,11.8475 6,9.8625 Z",
    id: "Shape",
    fill: "currentColor",
    fillRule: "nonzero"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuoteSmall);
export default __webpack_public_path__ + "static/media/icon-quote-small.57b940942bdc4a23c7089a851b40befe.svg";
export { ForwardRef as ReactComponent };